<script>
import formatTextUpperCasefirst from "@utils/format-text-upper-casefirst";

export default {
  props: {
    storeList: {
      type: Array,
      default: () => {
        return [
          {
            title: '台北店',
            storeType: 'home'
          }
        ]
      }
    },
  },
  computed: {
    storeType() {
      return this.storeList[0].storeType || ''
    },
    storeTagItem() {
      const storeTagMap = {
        'home': {
          title: '到府服務',
          icon: 'house'
        },
        'store': {
          title: '店面服務',
          icon: 'shop'
        }
      };

      return storeTagMap[this.storeType] || {}
    }
  },
  methods: {
    formatTextUpperCasefirst,
  }
}
</script>
<!-- section template -->
<template>
  <div :class="$style.baseStoreTagList">
    <div class="baseStoreTagList__item">
      <el-tag
        v-if="storeTagItem.title && $globalIsJtailsMode && !$globalIsDingBeauty"
        :class="`isStyle${formatTextUpperCasefirst(storeType)}`"
        class="baseStoreTagList__storeTag mr-2"
      >
        <i :class="`fontello fontello-${ storeTagItem.icon }`"></i>
        <span>{{ storeTagItem.title }}</span>
      </el-tag>
    </div>
    <div
      v-for="(storeItem, index) in storeList"
      :key="index"
      class="baseStoreTagList__item"
    >
      <el-tag 
        class="isSmall mr-2"
        :class="$globalIsDingBeauty ? 'isStyleGray isRadius-0' : 'isStyleDark isOutline'"
      >
        {{ storeItem.title }}
      </el-tag>
    </div>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.baseStoreTagList {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  :global {
    .baseStoreTagList {
      &__item {
        display: flex;
        align-items: center;
        height: 32px;
        margin-bottom: 0.25rem;
      }
      &__storeTag {
        padding: 0 12px !important;
        border-width: 0 !important;
        border-radius: 0 !important;

        :global {
          i {
            margin-right: 0.2em;
            font-size: 1.6em;
            vertical-align: middle;
          }

          span {
            vertical-align: middle;
          }
        }

        &.isStyleStore {
          color: $color-secondary;
          background: lighten($color-secondary-light, 9%);
        }

        &.isStyleHome {
          color: $color-primary;
          background: lighten($color-primary, 30%);
        }
      }
    }
  }
}
</style>
